import React from "react";
import { Modal } from "antd";
import FileUploader from "../FileUploader/Index";

interface ResumeUploaderProps {
  isOpen: boolean;
  handleClose: () => void;
  handleFileUploadAndAnalyze: (file: File) => void;
  handleContinueWithProfile: (profile: any) => void;
}

const ResumeUploader: React.FC<ResumeUploaderProps> = ({
  handleClose,
  isOpen,
  handleFileUploadAndAnalyze,
  handleContinueWithProfile,
}) => {
  return (
    <section className="resume-uploader-section">
      <Modal
        centered
        title="Upload Resume"
        open={isOpen}
        onCancel={handleClose}
        footer={null}
        width="100vw"
        className="full-width-modal"
      >
        <FileUploader
          handleNewlyUploadedFile={handleFileUploadAndAnalyze}
          handleSelectedProfile={handleContinueWithProfile}
          key="Resume-Uploader"
        />
      </Modal>
    </section>
  );
};

export default ResumeUploader;
